import * as React from "react";
import { forwardRef } from "react";
const SvgMicrosoftIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 34, height: 41, ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#f25022", d: "M13 11h9v9h-9z" }), /* @__PURE__ */ React.createElement("path", { fill: "#00a4ef", d: "M13 21h9v9h-9z" }), /* @__PURE__ */ React.createElement("path", { fill: "#7fba00", d: "M23 11h9v9h-9z" }), /* @__PURE__ */ React.createElement("path", { fill: "#ffb900", d: "M23 21h9v9h-9z" }));
const ForwardRef = forwardRef(SvgMicrosoftIcon);
export default ForwardRef;
